import React from "react";
import { Check } from "lucide-react";

const REASONS = [
  "Built specifically for K-12 environments",
  "Clear recommendations based on your needs",
  "Bundled packages available",
  "Supplies always available",
  "Ongoing support",
];

export default function PrintersWhy() {
  return (
    <section
      data-testid="printers-why-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
              Why ED Tech Depot
            </div>
            <h2
              data-testid="printers-why-headline"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
            >
              A Simpler Way for Schools to Print
            </h2>
          </div>

          <ul className="lg:col-span-7 space-y-1 lg:mt-3">
            {REASONS.map((r, i) => (
              <li
                key={r}
                data-testid={`printers-why-item-${i}`}
                className="group flex items-start gap-5 py-5 border-b border-slate-200 last:border-b-0 hover:bg-[#F4F6F4] px-2 -mx-2 rounded-lg transition-colors"
              >
                <span className="flex-shrink-0 mt-1 w-9 h-9 rounded-lg bg-teal/10 border border-teal/30 flex items-center justify-center group-hover:bg-teal group-hover:border-teal transition-colors">
                  <Check className="w-5 h-5 text-teal group-hover:text-white transition-colors" strokeWidth={3} />
                </span>
                <span className="font-serif text-lg sm:text-xl font-bold text-navy leading-snug pt-1">
                  {r}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
